var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiscoveryoval = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9443 80C63.5573 80 81.8887 62.0914 81.8887 40C81.8887 17.9086 63.5573 0 40.9443 0C18.3314 0 0 17.9086 0 40C0 62.0914 18.3314 80 40.9443 80Z",
    fill: "#5454D4",
    fillOpacity: 0.1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiscoveryoval);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/discoveryoval.f3f87503dd8e3e17ffb9adfa017888f8.svg";